import YakFetch from './utils/yak_fetch';
import ServiceBase from './service_base';

export default class TackIntervalSelector extends ServiceBase {

  static async fetchSelectionOptions(tackSlug, tackInterval) {
    const endpoint = `${process.env.REACT_APP_SERVICE_ENDPOINT_BASE}/api/tacks/${tackSlug}/tack_interval_selections/selections`;
    const response = await YakFetch.fetch(endpoint, 'PUT', { body: { tack_interval: tackInterval } });
    await TackIntervalSelector._abortIfUnsuccessful(response);
    const tackIntervalSelectionsData = await response.json();
    return tackIntervalSelectionsData;
  }

  static async select(tackSlug, tackIntervalSelectionMask) {
    const endpoint = `${process.env.REACT_APP_SERVICE_ENDPOINT_BASE}/api/tacks/${tackSlug}/tack_interval_selections`;
    const response = await YakFetch.fetch(endpoint, 'POST', { body: { tack_interval_selection_mask: tackIntervalSelectionMask } });
    await TackIntervalSelector._abortIfUnsuccessful(response);
    const tackIntervalSelectionData = await response.json();
    return tackIntervalSelectionData;
  }
}



// WEBPACK FOOTER //
// ./src/services/tack_interval_selector.js